import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'

import TwButton, { BUTTON_VARIANTS } from 'components/Button/TwButton'
import { ArrowFullRight } from 'components/Icons'
import { CART_STATE } from 'views/CartV2/consts'
import { cn } from 'utils'

import messages from '../../messages'

const PlaceOrderRow = ({ children, cartData }) => {
  const { formatMessage } = useIntl()
  const { actions, state } = cartData
  const { value } = state
  const { ordering } = actions

  const { variant, className, message } = useMemo(
    () => {
      if (value === CART_STATE.BLOCKED) {
        return {
          message: messages.orderCta,
          variant: BUTTON_VARIANTS.alert,
        }
      }

      if (value === CART_STATE.CONFIRMATION_REQUIRED) {
        return {
          message: messages.forApproval,
          variant: BUTTON_VARIANTS.warning,
        }
      }

      return {
        message: messages.orderCta,
        variant: BUTTON_VARIANTS.primaryLight,
      }
    },
    [cartData],
  )

  return (
    <div className="flex justify-between w-full lg:justify-normal lg:flex-col lg:gap-5 lg:w-auto">
      {children}
      <TwButton
        data-test-id="place-order-btn"
        className={cn('rounded-xl py-3 px-5 lg:py-[18px] lg:px-0', className)}
        variant={variant}
        disabled={!ordering.isAvailable}
      >
        <div className="flex gap-4 justify-center">
          <span className="text-m-h3">{formatMessage(message)}</span>
          {state.value === CART_STATE.CONFIRMATION_REQUIRED && (
            <ArrowFullRight
              className={cn(
                'hidden lg:block stroke-orange-900',
                !ordering.isAvailable && 'stroke-[#E0C4AA]',
              )}
            />
          )}
        </div>
      </TwButton>
    </div>
  )
}

export default PlaceOrderRow
